import moment from 'moment';

export default class ChartCanvas {
  constructor({
    total,
    labels,
    series,
    data,
    destinationId,
    ownerId,
    startDate,
    endDate,
    fill,
    borderWidth,
    tension,
  }) {
    this.total = total;
    this.labels = labels;
    this.series = series;
    this.data = data;
    this.destinationId = destinationId;
    this.ownerId = ownerId;
    this.startDate = moment(startDate);
    this.endDate = moment(endDate);
    this.fill = fill;
    this.borderWidth = borderWidth;
    this.tension = tension;
    this.isSingleDay = moment.duration(this.endDate.diff(this.startDate)).asHours() < 24;
  }

  static fromAttributes(...properties) {
    return new ChartCanvas(...properties);
  }
}
